import {camelize} from "@/helper/String";

export const GEO = 'geo';
export const TRAVEL_WILLINGNESS = 'travel-willingness';
export const EXTERNAL_SLEEPOVER = 'external-sleepover';

export const FUNCTION_SCOPE = 'function-scope';
export const FUNCTION_ASSISTANCE = 'function-assistance';
export const FUNCTION_LEGAL_FIELD = 'function-legal-field';
export const FUNCTION_LEGAL_ROLE = 'function-legal-role';
export const FUNCTION_TAX_FIELD = 'function-tax-field';
export const FUNCTION_TAX_ROLE = 'function-tax-role';
export const MARKETING_AREA = 'marketing-area';

export function getById (typeId, meta)
{
	return meta[camelize(typeId) + 'Type'];
}
